module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    gray: '#F4F4F4',
                    blue: '#05AFFF',
                    pink: '#FF00FF',
                }
            },
        },
        fontFamily: {
            roboto: ['Roboto', 'sans-serif'],
            azosans: ['azosans', 'sans-serif'],
            gotham: ['gotham', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
